import useAllowChangeRoute from 'hooks/useAllowChangeRoute';
import React, { ElementType, ReactNode, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';
import { DropdownItem } from 'plataforma-fundacao-componentes';

export interface ITopBarSubMenuItem {
  label: string;
  icon?: ReactNode | ElementType;
  path?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  click?: any;
  disabled?: boolean;
}

export default function TopBarSubMenuItem({
  label,
  icon,
  path,
  onClick,
  click,
  disabled,
}: ITopBarSubMenuItem) {
  const history = useHistory();
  const [handleChangeRoute] = useAllowChangeRoute();

  const getIcon = useCallback(() => {
    if (typeof icon === 'function') {
      const Component: any = icon;
      return <Component />;
    }
    return icon;
  }, [icon]);

  const onClicked = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (typeof onClick === 'function') {
        onClick(event);
        click(event);
      }
    },
    [onClick, click]
  );

  return (
    <div className={styles.dropbutton}>
      <DropdownItem
        label={label}
        disabled={disabled}
        icon={getIcon()}
        onClick={(e) => {
          onClicked(e);
          if (path) {
            handleChangeRoute().then(() => {
              history.push(path);
            });
          }
        }}
      />
    </div>
  );
}
